import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';

export const FETCH_UNIT_QUIZ_RESULTS_REQUEST = 'FETCH_UNIT_QUIZ_RESULTS_REQUEST';
export const FETCH_UNIT_QUIZ_RESULTS_SUCCESS = 'FETCH_UNIT_QUIZ_RESULTS_SUCCESS';
export const FETCH_UNIT_QUIZ_RESULTS_FAILURE = 'FETCH_UNIT_QUIZ_RESULTS_FAILURE';

const buildUnitQuizResultsUrl = (groupId) => buildUrl(`/groups/${groupId}/unit-quiz-results`);

export function fetchUnitQuizResultsIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildUnitQuizResultsUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchUnitQuizResultsContent(groupId));
  };
}

export function fetchUnitQuizResultsContent(groupId) {
  return (dispatch) => {
    const url = buildUnitQuizResultsUrl(groupId);
    const method = 'GET';

    return dispatch(fetchUnitQuizResultsRequest()).payload
      .then((response) => dispatch(fetchUnitQuizResultsSuccess(response)))
      .catch((error) => dispatch(fetchUnitQuizResultsFailure(error)));

    function fetchUnitQuizResultsRequest() {
      return ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchUnitQuizResultsSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchUnitQuizResultsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/UnitQuiz/actions.js